import { GameColor } from '@colonist/ui-game';
import { UIGameFeed } from '../../../../../shared/scripts/ui_game/ui_game_feed/UIGameFeed.ts';
import { createDivIn, createHeaderIn, createImgIn, createParagraphIn, createSelectIn, setElementInnerHTML, setElementOnClick } from '../../../../../shared/scripts/ui_utils/DomUtils.ts';
import { LobbyImage } from '@colonist/types';
import { socket } from '../../../../../shared/scripts/EntryShared.ts';
export class UIRoomPlayOrderSelectionView extends UIGameFeed {
    update(newRoomState, data) {
        this.roomState = newRoomState;
        this.playOrderSelectionData = data;
        this.updateTitle();
        this.createSessionViews();
    }
    setInitialSizeAndPosition(canvas) {
        const canvasX = canvas.responsiveController.getCanvasX();
        const canvasY = canvas.responsiveController.getCanvasY();
        const w = canvas.chatWidth;
        const h = canvas.appH - canvas.itemSize * 5.5;
        this.setSize(w, h);
        this.setPosition(canvasX, canvasY);
    }
    setPosition(canvasX, canvasY) {
        const MARGIN = this.gameManager.canvasController.margin;
        this.setPositionRight(canvasX + MARGIN * 2);
        this.setPositionTop(canvasY + MARGIN);
    }
    setSize(w, h) {
        const margin = this.gameManager.canvasController.margin;
        const divHeight = h;
        this.scale(1);
        this.mainBlock.style.marginTop = margin + 'px';
        this.setHeight(divHeight * 2);
        this.setWidth(w - margin * 2);
    }
    resizeSelectionView(newAppW, newAppH) {
        const canvas = this.gameManager.canvasController;
        const wRatioChanged = newAppW / canvas.appW;
        const hRatioChanged = newAppH / canvas.appH;
        const canvasX = canvas.responsiveController.getCanvasX();
        const canvasY = canvas.responsiveController.getCanvasY();
        const w = wRatioChanged * canvas.chatWidth;
        const h = hRatioChanged * (canvas.appH - canvas.itemSize * 5.5);
        this.setSize(w, h);
        this.setPosition(canvasX, canvasY);
    }
    updateTitle() {
        var _this_roomState_getSessions_find;
        var _this_roomState_getSessions_find_username;
        const currentSelectorUsername = (_this_roomState_getSessions_find_username = (_this_roomState_getSessions_find = this.roomState.getSessions().find((session)=>session.selectedColor == this.playOrderSelectionData.currentSelector)) === null || _this_roomState_getSessions_find === void 0 ? void 0 : _this_roomState_getSessions_find.username) !== null && _this_roomState_getSessions_find_username !== void 0 ? _this_roomState_getSessions_find_username : '';
        const mySession = this.roomState.getSessions().find((session)=>session.userSessionId == socket.controller.session.id);
        const amICurrentSelector = this.playOrderSelectionData.currentSelector == (mySession === null || mySession === void 0 ? void 0 : mySession.selectedColor);
        const titleText = amICurrentSelector ? {
            key: 'strings:roomPage.orderSelection.playOrderSelection.yourTurn'
        } : {
            key: 'strings:roomPage.orderSelection.playOrderSelection.playerSelecting',
            options: {
                username: `${currentSelectorUsername}`
            }
        };
        setElementInnerHTML(this.titleView, titleText);
    }
    createSessionViews() {
        setElementInnerHTML(this.playerViews, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: ''
            }
        });
        const sessions = this.roomState.getSessions();
        const mySession = this.roomState.getSessions().find((session)=>session.userSessionId == socket.controller.session.id);
        const sessionsOrderedBySeed = this.seedOrderData.seedOrder.sort((a, b)=>a[0] - b[0]);
        const takenPlayOrders = this.playOrderSelectionData.playOrder.map((singleSession)=>singleSession[1]);
        sessionsOrderedBySeed === null || sessionsOrderedBySeed === void 0 ? void 0 : sessionsOrderedBySeed.forEach((session, index)=>{
            var _sessions_find, _sessions_find1, _this_playOrderSelectionData;
            const playerColor = session[1];
            const sessionDiv = createDivIn(this.playerViews, 'session-view');
            sessionDiv.style.background = GameColor.getLighterGradientOfPlayerColor(playerColor);
            var _sessions_find_icon;
            const icon = (_sessions_find_icon = (_sessions_find = sessions.find((clientState)=>clientState.selectedColor == playerColor)) === null || _sessions_find === void 0 ? void 0 : _sessions_find.icon) !== null && _sessions_find_icon !== void 0 ? _sessions_find_icon : LobbyImage.InfoIcon;
            const userIcon = createImgIn(sessionDiv, icon, 'user-icon');
            var _sessions_find_username;
            const userName = (_sessions_find_username = (_sessions_find1 = sessions.find((clientState)=>clientState.selectedColor == playerColor)) === null || _sessions_find1 === void 0 ? void 0 : _sessions_find1.username) !== null && _sessions_find_username !== void 0 ? _sessions_find_username : 'NameNotFound';
            const username = createParagraphIn(sessionDiv, {
                key: 'strings:colonistCommon.utils.#buffer',
                options: {
                    value: userName
                }
            }, 'username');
            const dropdown = createSelectIn(sessionDiv, 'play-order-selection-dropdown', undefined, (value)=>this.onDropdownValueChange(value, playerColor));
            UIRoomPlayOrderSelectionView.setDropdownOptions(dropdown, sessions, takenPlayOrders);
            sessionDiv.appendChild(userIcon);
            sessionDiv.appendChild(username);
            sessionDiv.appendChild(dropdown);
            const previouslySetEntryOfPlayer = this.playOrderSelectionData.playOrder.find(([color, order])=>color == playerColor);
            const previouslySelectedPlayOrder = previouslySetEntryOfPlayer === null || previouslySetEntryOfPlayer === void 0 ? void 0 : previouslySetEntryOfPlayer[1];
            const isPlayOrderSetBefore = previouslySelectedPlayOrder != undefined;
            if (isPlayOrderSetBefore) dropdown.value = previouslySelectedPlayOrder.toString();
            const isMySelectionBox = playerColor == (mySession === null || mySession === void 0 ? void 0 : mySession.selectedColor);
            const isCurrentSelector = playerColor == ((_this_playOrderSelectionData = this.playOrderSelectionData) === null || _this_playOrderSelectionData === void 0 ? void 0 : _this_playOrderSelectionData.currentSelector);
            const shouldDisableDropdown = !isMySelectionBox || isPlayOrderSetBefore || !isCurrentSelector;
            dropdown.disabled = shouldDisableDropdown;
            if (isMySelectionBox) {
                this.myOrderSelectionBox = dropdown;
                this.myColor = playerColor;
            }
            if (shouldDisableDropdown) return;
            const checkmarkButton = createDivIn(this.playerViews, 'btn_general btn_general_check checkmark_button');
            setElementOnClick(checkmarkButton, ()=>this.onConfirmSelection());
        });
    }
    onConfirmSelection() {
        const order = parseInt(this.myOrderSelectionBox.value, 10);
        if (isNaN(order)) return;
        this.myOrderSelectionBox.disabled = true;
        socket.roomClient.setPlayOrder(order);
    }
    onDropdownValueChange(value, selector) {
        var _this_playOrderSelectionData;
        if (selector != ((_this_playOrderSelectionData = this.playOrderSelectionData) === null || _this_playOrderSelectionData === void 0 ? void 0 : _this_playOrderSelectionData.currentSelector)) return;
        this.myOrderSelectionBox.value = value;
    }
    static setDropdownOptions(dropdown, sessions, takenPlayOrders) {
        const defaultOption = document.createElement('option');
        defaultOption.value = '-';
        defaultOption.textContent = '-';
        dropdown.appendChild(defaultOption);
        for(let i = 1; i <= sessions.length; i++){
            const option = document.createElement('option');
            option.value = i.toString();
            option.textContent = i.toString() + UIRoomPlayOrderSelectionView.getOrdinalIndicatorForPlayOrder(i);
            if (takenPlayOrders === null || takenPlayOrders === void 0 ? void 0 : takenPlayOrders.includes(i)) option.disabled = true;
            dropdown.appendChild(option);
        }
    }
    static getOrdinalIndicatorForPlayOrder(order) {
        if (order == 1) return 'st';
        if (order == 2) return 'nd';
        if (order == 3) return 'rd';
        return 'th';
    }
    constructor(gameManager, roomState, playOrderData, seedOrderData){
        super('play-order-selection-view-container', 'game-chat-block');
        this.playOrderSelectionData = playOrderData;
        this.seedOrderData = seedOrderData;
        this.gameManager = gameManager;
        this.roomState = roomState;
        const canvas = gameManager.canvasController;
        this.setInitialSizeAndPosition(canvas);
        window.addEventListener('resize', ()=>this.resizeSelectionView(canvas.appW, canvas.appH));
        this.titleView = createHeaderIn(this.container, {
            key: 'strings:roomPage.orderSelection.playOrderSelection.title'
        }, 'play-order-selection-title');
        this.playerViews = createDivIn(this.container, 'play-order-selection-view-container');
        this.createSessionViews();
        this.mainBlock.style.backgroundImage = 'none';
    }
}
